import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

function sliderCollaboration() {
  new Swiper('.about-collaboration__slider .swiper', {
    modules: [ Scrollbar ],
    spaceBetween: 12,
    slidesPerView: 1,
    grabCursor: true,
    breakpoints: {
      1226: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
  });
}
sliderCollaboration();